import React, { useEffect, useState } from 'react';
import { useParams, Outlet } from 'react-router';

import { ErrorPage } from '@everfi/reactifi';

import Fallback from '../layout/FallBack';

import { checkAuthenticated } from './authentication';
import { useTokenStore } from './TokenStore';

// login code borrowed from https://github.com/kdhttps/appauth-react
// and related blog: https://dev.to/kdhttps/appauth-js-integration-in-react-1m3e
const Authenticated = ({ app }) => {
  const tokenStore = useTokenStore();
  const [authenticated, setAuthenticated] = useState('pending');
  const { slug, program_slug } = useParams();

  useEffect(() => {
    const checkSession = async () => {
      try {
        setAuthenticated(await checkAuthenticated(slug, program_slug, tokenStore, app));
      } catch (e) {
        setAuthenticated('failed');
      }
    };
    checkSession();
  }, [app, slug, program_slug, tokenStore]);

  if (authenticated === 'pending' || !authenticated) {
    return <Fallback />;
  } else if (authenticated === 'failed') {
    const errorMessage = [
      'We had trouble authenticating you, please try refreshing the page or go back to the login page to try again',
    ];

    return (
      <Fallback>
        <ErrorPage errors={errorMessage} title="Cannot authenticate" />
      </Fallback>
    );
  } else if (authenticated) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default Authenticated;
